<template>
  <div>
    <chart ref="carSaleTotal" :height="300" :option="carSaleTotalOption()" />
  </div>
</template>
<script>
import Chart from "@/components/chart";

// （柱状 | 折现）图
function getBarOrLineChartOption(config = {}) {
  return {
    title: {
      text: config.title,
      top: 10,
      left: 50,
      textStyle: {
        fontSize: 16
      }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    legend: {
      show: config.legend,
      data: config.legend,
      bottom: 5
    },
    grid: config.grid,
    xAxis: {
      type: config.xAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.xAxis
    },
    yAxis: {
      type: config.yAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.yAxis
    },
    series: config.series
  };
}

export default {
  name: "carSaleTotal",
  components: {
    Chart
  },
  data() {
    return {
      carSaleTotalStatis: {
        dataList: []
      }
    };
  },
  methods: {
    // 获取统计数据
    async getStatisData(saleCarTotal = {}) {
      this.carSaleTotalStatis.dataList = saleCarTotal.data;
    },
    // 车辆销售总量
    carSaleTotalOption() {
      const config = {
        title: "车辆销售总量",
        grid: { bottom: 60, top: 60, left: 120, right: 120 },
        xAxisType: "category",
        yAxisType: "value",
        xAxis: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        series: [
          {
            name: "销售量",
            type: "bar",
            color: "#5087EC",
            data: this.carSaleTotalStatis.dataList,
            barCategoryGap: "50%", // 类目间隔
            barGap: "0", // 系列间隔
            label: {
              show: true,
              position: "top"
            }
          }
        ]
      };
      return getBarOrLineChartOption(config);
    }
  }
};
</script>

<style scoped lang="scss"></style>
